<template>
  <div class="client-bids">
    <div class="container-fluid client">
      <div class="clientWrap">
        <div class="row">
          <div class="col-md-12 py-4 text-left">
            <div class="d-flex justify-content-between align-items-center">
              <h1>Settings</h1>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="history filter-list">
              <div class="table-responsive p-0">
                <div class="settings-card">
                  <div class="settings-row">
                    <label class="settings-label"
                      >Current Password</label
                    >
                    <input
                      class="form-control"
                      type="password"
                      placeholder="Current Password"
                       autocomplete="new-password"
                      style="width: 450px"
                      v-model="currentpassword"
                    />
                  </div>
                  <div class="settings-row">
                    <label class="settings-label"
                      >New Password</label
                    >
                     <input
                      class="form-control"
                      type="password"
                      placeholder="New Password"
                      style="width: 450px"
                      v-model="newpassword"
                    />
                  </div>
                  <div class="settings-row">
                    <label class="settings-label"
                      >Confirm Password</label
                    >
                     <input
                      class="form-control"
                      placeholder="Confirm Password"
                      type="password"
                      v-model="confirmpassword"
                      style="width: 450px"
                    />
                  </div>
                </div>
                   <br />
                <div v-if="error.message" class="alert alert-danger" role="alert">
                  <i class="fas fa-exclamation-triangle"></i>
                  {{error.message}}
                </div>
                <div class="alert alert-success" role="alert" v-if="passwordChanged">
                  <i class="fas fa-check-circle"></i>
                  Password changed successfully.
                </div>
                <div class="text-center">
                  <button type="submit" class="btn btn-primary my-2" @click="change">
                    CHANGE PASSWORD
                    <i
                      v-if="!loading"
                      class="fa fa-arrow-circle-right"
                      aria-hidden="true"
                    ></i>
                    <i v-if="loading" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/config";
import authService from "@/authService";

export default {
  name: "viewdata",
  components: {
    // Header,
    // Footer
  },
  data() {
    return {
      accessToken: null,
      users: [],
      config: config,
      currentpassword: "",
      newpassword: "",
      confirmpassword: "",
      error: {},
      loading: false,
      passwordChanged: false,
      cognitoidentityserviceprovider: null
    };
  },
  created() {
    this.user = this.$cognitoAuth.getCurrentUser();
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        this.error = err;
      } else {
        this.accessToken = result;
      }
    });
    // const userPoolLoginKey = config.userPoolLoginKey;
    // const logins = {};
    // logins[userPoolLoginKey] = this.accessToken;
    // AWS.config.region = config.region;
    // const cognitoParams = {
    //   IdentityPoolId: config.IdentityPoolIdFileUpload,
    //   Logins: logins
    // };
    // this.cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider(
    //   {
    //     region: "us-east-1",
    //     credentials: new AWS.CognitoIdentityCredentials(cognitoParams)
    //   }
    // );
    // cognitoidentityserviceprovider.listUsers(
    //   { UserPoolId: "us-east-1_lPsGMCeW4" },
    //   (err, data) => {
    //     if (err) {
    //       console.log(err);
    //     } else {
    //       this.users = data.Users;
    //     }
    //   }
    // );
    
    
  },
  methods: {
    setUserLastPasswordReset(){
      let user = authService.getUser();
      let dataToSend = {"username": user.email}
      const auth = {
          headers: { }
      };
      this.$http.post(config.baseUrlLamda,dataToSend,auth)
      .then(() => {
        // Step 1: Get the user object from localStorage
        const user = JSON.parse(localStorage.getItem('user'));
        // Step 2: Delete the 'lastPasswordChange' property
        delete user.lastPasswordChange;
        // Step 3: Save the updated object back to localStorage
        localStorage.setItem('user', JSON.stringify(user));
        window.location.href = '/dashboardoption';

      })

    },
    getEmailFromAttr(data) {
      //console.log(data);
      var obj = data.find(res => res.Name == "email");
      if (obj) {
        return obj.Value;
      } else {
        return "Email is not added";
      }
    },
    change(e) {
      e.preventDefault();
      this.error = { message: "" };
      if (
        this.newpassword == "" ||
        this.confirmpassword == "" ||
        this.currentpassword == ""
      ) {
        this.error = {
          message:
            "Current password,New password and confirm password is required"
        };
        return false;
      }
      if (this.newpassword == this.confirmpassword) {
        // var params = {
        //   AccessToken: this.accessToken /* required */,
        //   PreviousPassword: this.currentpassword /* required */,
        //   ProposedPassword: this.newpassword /* required */
        // };
        this.loading = true;
        var self = this;
        if (this.user != null) {
          this.user.getSession(function(err, data) {
            if (err) {
              alert(err);
              return;
            } else {
              console.log("data", data);
            }
          });

          this.user.changePassword(
            this.currentpassword,
            this.newpassword,
            function(err) {
              if (err) {
                self.error = err;
                console.log(err);
                self.loading = false;
              } else {
                self.loading = false;
                self.passwordChanged = true;
                self.setUserLastPasswordReset()
              }
            }
          );
        }
        // this.$cognitoAuth.changePassword(
        //   this.currentpassword,
        //   this.newpassword,
        //   err => {
        //     if (err) {
        //       //console.log("login error",err);
        //       this.error = err;
        //       this.loading = false;
        //     } else {
        //       alert("Password changed successfully");
        //       // this.loading = false;
        //       // this.$router.push("/dashboard");
        //     }
        //   }
        // );
        // this.cognitoidentityserviceprovider.changePassword(params, function(
        //   err,
        //   data
        // ) {
        //   if (err){
        //       this.error = err;
        //       this.loading = false;
        //       console.log(err, err.stack);
        //   }
        //   // an error occurred
        //   else {
        //       this.loading = false;
        //       //alert("Password reset successfully. Please login with your new password ");
        //       console.log(data);
        //       } // successful response
        // });
      } else {
        this.error = {
          message: "New password and confirm password do not match"
        };
      }
    }
  },
  mounted() {}
};
</script>

<style scoped>
.settings-card {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
}

.settings-row {
  display: flex;
  align-items: center;
  gap: 20px;
}

.settings-label {
  width: 250px; /* Fixed label width */
  font-size: 14px;
  font-weight: 500;
  color: #bbbbbb;
}

.settings-input {
  width: 350px; /* FIX INPUT WIDTH */
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.button-wrap {
  display: flex;
  justify-content: flex-end; /* Button moves to right */
  margin-top: 10px;
}
</style>
